<template>
    <div class="basic-info">
        <el-form
          ref="ruleForm"
          label-position="top"
          size='small'
          :model="form"
          :rules="rules"
        >
        <div>
            <div class="font-medium flex items-center border-b border-gray-200 dark:border-dark-5 pb-5">
                <ChevronDownIcon class="w-4 h-4 mr-2" /> 基本信息
            </div>
            <div class="grid grid-cols-12 mt-5">
                <div class="col-span-6 pr-10">
                    <el-form-item label="单位管理名称" prop="companyId">
                        <el-select style="width: 100%;" v-model="form.companyId" placeholder="请选择管理单位">
                            <el-option v-for="item in unitNameOptions" :label='item.name' :value="item.id" :key="item.name">
                                {{item.name}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="资产来源" prop="assetSource">
                        <el-select style="width: 100%;" v-model="form.assetSource" placeholder="请选择">
                            <el-option v-for="item in sourceOptions" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="有无房地产权证" prop="hasEstateCertificate" :labelCol="{span:10}">
                        <el-select style="width: 100%;" v-model="form.hasEstateCertificate" placeholder="请选择">
                            <el-option v-for="item in propertyROptions" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item prop='certificateAddress' ref="certificateAddress" label="资产产权证地址：">
                        <el-input placeholder='请输入资产产权地址' v-model="form.certificateAddress" @blur="() => {$refs.certificateAddress.onFieldBlur();}"/>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="产证编号：">
                        <el-input placeholder='请输入产证编号' v-model="form.certificateNumber"/>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item prop='buildingArea' label="房屋建筑面积(㎡)：">
                        <el-input placeholder='请输入面积' v-model="form.buildingArea"/>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="房屋建筑物账面价值(元)：" prop=''>
                        <el-input placeholder='请输入'  v-model="form.buildingBookValue" />
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="房屋建筑物净值(元)：" prop=''>
                        <el-input placeholder='请输入' v-model="form.buildingNetWorth" />
                    </el-form-item>
                </div><div class="col-span-6 pr-10">
                    <el-form-item ref="landArea" label="土地面积(㎡)：" prop=''>
                        <el-input placeholder='请输入面积' v-model="form.landArea" />
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item ref="landBookValue" label="土地账面价值(元)：" prop=''>
                        <el-input placeholder='请输入' v-model="form.landBookValue" />
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item ref="oldLandCertificateNumber" label="老版土地证号：" prop=''>
                        <el-input placeholder='请输入' v-model="form.oldLandCertificateNumber"/>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item ref="estateCertificateNumber" label="老版房屋证号或新版房地产权证号：" prop=''>
                        <el-input placeholder='请输入' v-model="form.estateCertificateNumber" />
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="资产所在区：" prop="assetAddress">
                        <el-cascader
                            style='width: 100%;'
                        v-model="form.assetAddress"
                        @change="areaChange"
                        :options='address'
                        :props="{ label: 'name', value: 'id', children: 'children' }"
                        placeholder="请选择资产所在区域"
                        />
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="所在街镇：" prop="">
                        <el-select style="width: 100%;" v-model="form.assetStreet" placeholder="请选择">
                            <el-option v-for="item in townList" :value="item.id" :label='item.name' :key="item.name">
                                {{item.name}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="资产实际所有人与产权证登记权利人是否一致：" prop="" :labelCol="{span:10}">
                        <el-select style="width: 100%;" v-model="form.isActualOwner" placeholder="请选择">
                            <el-option v-for="item in toggleFlagOptions" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="资产实际所有人：" prop="actualOwnerId">
                        <el-select style="width: 100%;" v-model="form.actualOwnerId" placeholder="请选择">
                            <el-option v-for="item in unitNameOptions" :value="item.id" :label='item.name' :key="item.name">
                                {{item.name}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="所有权证登记权利人：" prop=''>
                        <el-input placeholder='请输入' v-model="form.certificateOwner" />
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="产证原件保管单位：" prop=''>
                        <el-input placeholder='请输入' v-model="form.certificateCustodian" />
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="产证土地用途：" prop="">
                        <el-select style="width: 100%;" v-model="form.landUseFor" placeholder="请选择">
                            <el-option v-for="item in purposeOptions" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="产证房屋用途：" prop="">
                        <el-select style="width: 100%;" v-model="form.buildingUseFor" placeholder="请选择">
                            <el-option v-for="item in purposeOptions" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="实际用途：" prop="actualUseFor">
                        <el-select style="width: 100%;" v-model="form.actualUseFor" placeholder="请选择">
                            <el-option v-for="item in purposeOptions" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="土地使用权来源：" prop=''>
                        <el-select style="width: 100%;" v-model="form.useRightSource" placeholder="请选择">
                            <el-option v-for="item in useRightSource" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="它项权利限制情况：" prop=''>
                        <el-input placeholder='请输入' v-model="form.restriction" />
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="是否为只管公房：" prop="isStraightBuilding">
                        <el-select style="width: 100%;" v-model="form.isStraightBuilding" placeholder="请选择">
                            <el-option v-for="item in toggleFlagOptions" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="定价方式：" prop="">
                        <el-select style="width: 100%;" v-model="form.pricingMethod" placeholder="请选择">
                            <el-option v-for="item in priceMode" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-span-6 pr-10">
                    <el-form-item label="已租赁：" prop="">
                        <el-select style="width: 100%;" v-model="form.isLease" placeholder="请选择">
                            <el-option v-for="item in rented" :value="item.value" :label='item.key' :key="item.key">
                                {{item.key}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
        </div>
        </el-form>
    </div>
</template>
<script>
import {getCompanyList} from '@/api/asset.js'
import {getTownsByArea} from '@/api/open.js'
import {mapState} from 'vuex'
export default {
    name:'basicInfoEdit',
    data(){
        return{
            unitNameOptions:[],
            sourceOptions:[
                {value:'',key:'请选择'},
                {value:'托管',key:'托管'},
                {value:'不填报',key:'不填报'},
                {value:'租转',key:'租转'},
                {value:'集团公司',key:'集团公司'},
                {value:'自有',key:'自有'},
                {value:'国资委',key:'国资委'},
            ],
            propertyROptions:[
                {value:'',key:'请选择'},
                {value:'1',key:'有'},
                {value:'0',key:'无'},
            ],
            townList:[],
            toggleFlagOptions:[
                {value:'',key:'请选择'},
                {value:'1',key:'是'},
                {value:'0',key:'否'},
            ],
            purposeOptions:[
                {value:'',key:'请选择'},
                {value:'商业',key:'商业'},
                {value:'办公',key:'办公'},
                {value:'居住',key:'居住'},
                {value:'工业',key:'工业'},
                {value:'其他',key:'其他'},
            ],
            useRightSource:[
                {value:'',key:'请选择'},
                {value:'划拨',key:'划拨'},
                {value:'出让',key:'出让'}
            ],
            priceMode:[
                {value:'',key:'请选择'},
                {value:'其他',key:'其他'},
                {value:'询价',key:'询价'},
                {value:'评估',key:'评估'},
            ],
            rented:[
                {value:null,key:'请选择'},
                {value:1,key:'是'},
                {value:0,key:'否'},
            ],
            form: {
                companyId:'',
                assetSource:'',
                hasEstateCertificate:'',
                certificateAddress:'',
                certificateNumber:'',
                buildingArea:'',
                buildingBookValue:'',
                buildingNetWorth:'',
                landArea:'',
                landBookValue:'',
                oldLandCertificateNumber:'',
                estateCertificateNumber:'',
                assetAddress:[],
                assetStreet:'',
                isActualOwner:'',
                actualOwnerId:'',
                certificateOwner:'',
                certificateCustodian:'',
                landUseFor:'',
                buildingUseFor:'',
                actualUseFor:'',
                useRightSource:'',
                restriction:'',
                isStraightBuilding:'',
                pricingMethod:'',
            },
            labelCol: { span: 20 },
            wrapperCol: { span: 14 },
            rules: {
                companyId: [
                    { required: true, message: '请选择管理单位名称', trigger: 'change' },
                ],
                assetSource: [
                    { required: true, message: '请选择资产来源', trigger: 'change' },
                ],
                hasEstateCertificate: [
                    { required: true, message: '请选择有无房地产权证', trigger: 'change' },
                ],
                certificateAddress: [
                    { required: true, message: '请输入资产产权证地址', trigger: 'blur' },
                ],
                buildingArea: [
                    { required: true, message: '请输入房屋建筑面积', trigger: 'blur' },
                ],
                assetAddress:[
                    { required: true, message: '请选择资产所在区', trigger: 'change' },
                ],
                actualOwnerId:[
                    { required: true, message: '请选择资产实际所有人', trigger: 'change' },
                ],
                actualUseFor:[
                    { required: true, message: '请选择实际用途', trigger: 'change' },
                ],
                isStraightBuilding:[
                    { required: true, message: '请选择是否为直管公房', trigger: 'change' },
                ],
            },
            areaId:'',
        }
    },
    computed:{
        ...mapState({
            address:state=>state.public.address
        })
    },
    watch:{
        ['form.assetAddress']:{
            handler:function(){
                if(this.form.assetAddress){
                    this.areaId=this.form.assetAddress[2];
                    this.getTowns();
                }
            },
            deep:true
        }
    },
    methods:{
        getTowns(){
            getTownsByArea({areaId:this.areaId}).then(res=>{
                let data=res.data;
                if(data.code==='000'){
                    this.townList=data.content.townList;
                }else{
                    console.log(data.desc)
                }
            })
        },
        areaChange(val){
            console.log(val)
            this.areaId=val[2];
            this.form.assetStreet='';
            this.getTowns();
        },
        getCompanyLists(){
            getCompanyList().then(res=>{
            let data=res.data;
            if(data.code==='000'){
                let resList=data.content.list;
                this.unitNameOptions=resList.filter((item)=>{
                    return item.id!==-1;
                })

            }else{
                console.log(data.desc)
            }
            })
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    created(){
        this.getCompanyLists();
    }

}
</script>


